import React from 'react';
import PropTypes from 'prop-types';
import AppDrawer from '@afosto/components-react/AppDrawer';
import { useAppActions, useAppState } from '../AppProvider';

const Drawer = ({ children }) => {
  const { isDrawerOpen } = useAppState();
  const [actions] = useAppActions();

  return (
    <AppDrawer
      open={isDrawerOpen}
      onClose={() => actions.setIsDrawerOpen(false)}
      ModalProps={{ keepMounted: true }}
    >
      {children}
    </AppDrawer>
  );
};

Drawer.defaultProps = {
  children: undefined,
};

Drawer.propTypes = {
  children: PropTypes.node,
};

export default Drawer;
